import { render, staticRenderFns } from "./EvalExtraQuestions.vue?vue&type=template&id=79d61f36&scoped=true"
import script from "./EvalExtraQuestions.vue?vue&type=script&lang=js"
export * from "./EvalExtraQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d61f36",
  null
  
)

export default component.exports